import { render, staticRenderFns } from "./HeatArea.vue?vue&type=template&id=01c5d022&"
import script from "./HeatArea.vue?vue&type=script&lang=js&"
export * from "./HeatArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports